import { toast } from "@replohq/lattice/components/toast/Toast";

export const showSubscriptionUpdateSuccessToast = () => {
  return toast.success({ title: "Plan Updated Successfully" });
};

// Set by the add-on approval banner right before it redirects the merchant to
// Shopify to approve their corrected charge, and read on return so we can show a
// tailored confirmation. The undercharge flag that drives the banner is only
// cleared by the daily billing audit, so the banner itself lingers for up to a
// day after approval — the tailored toast sets that expectation.
export const ADDON_APPROVAL_CONFIRMATION_PENDING_KEY =
  "replo.billing.addonApprovalConfirmationPending";

export const showAddonApprovalConfirmationToast = () => {
  return toast.success({
    title: "Charge approved",
    description:
      "Your add-ons are active now. The reminder banner can take up to a day to clear — no further action needed.",
  });
};
